module.exports = __webpack_public_path__ + "img/black.16b09913.png";